/**
 * Classe responsável pelo formulário de busca.
 *
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 09/08/2013
 *
 */


Greenmile.ServiceTimeUpdates = Greenmile.ServiceTimeUpdates || {};

Greenmile.ServiceTimeUpdates.FormSearch = function () {

    var validateDateAndMinutes = function () {

        var error               = null,
            dateStart           = null,
            dateEnd             = null,
            dateStartValue      = null,
            dateEndValue        = null,
            dateGf              = null,
            dateEndIsGreather   = true,
            dataEndIsInFuture   = false,
            minTimeStart        = null,
            minTimeEnd          = null,
            minTimeEndIsGreater = true,
            validate            = { status: true, errorMessages: [] },
            form                = App.Forms.ServiceTimeUpdates.form,
            fields              = form.fields;

        try {
            dateGf = new Monet.Date.GeneralFunctions();
            dateStart = fields.start;
            dateEnd = fields.end;
            dateStartValue = dateStart.getValue();
            dateEndValue = dateEnd.getValue();

            minTimeStart = document.querySelector("#ServiceTimeUpdates input[name='minTimeStart']");
            minTimeEnd = document.querySelector("#ServiceTimeUpdates input[name='minTimeEnd']");

            if (dateStartValue && dateEndValue) {

                dateEndIsGreather = dateGf.validateDateGreaterOrEqualThan(dateStartValue, dateEndValue);
                dataEndIsInFuture = dateGf.validateIfDateIsInFuture(dateEndValue);

                if (!dateEndIsGreather) {

                    validate.status = false;
                    validate.errorMessages
                        .push(
                            Monet.Form.Messages.mountErrorMessageObject('ServiceTimeUpdates.message.dateStartIsGreather'));
                }

                if (dataEndIsInFuture) {

                    validate.status = false;
                    validate.errorMessages
                        .push(
                            Monet.Form.Messages.mountErrorMessageObject('ServiceTimeUpdates.message.dateEndIsInFuture')
                        );
                }
            }
            if (minTimeStart !== null && minTimeEnd !== null && minTimeStart.value !== "" && minTimeEnd.value !== "") {

                minTimeEndIsGreater = dateGf.endHourIsGreaterOrEqualThanBeginningHour(minTimeStart.value, minTimeEnd.value);

                if (!minTimeEndIsGreater) {

                    validate.status = false;
                    validate.errorMessages
                        .push(
                            Monet.Form.Messages.mountErrorMessageObject('ServiceTimeUpdates.message.minTimeStartIsGreather'));
                }

            }

            return validate;

        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Error on validate date.", e);
            error.console();
        }
    };

    var getValuesFromForm = function () {
        const fields = App.Forms.ServiceTimeUpdates.form.getValues();
        const notSendNull = ["accountType", "location", "organization"];

        notSendNull.forEach(function (item) {
            if (fields[item].length === 0 || fields[item] === 0) {
                delete fields[item];
            }
            if (fields[item] instanceof Array) {
                fields[item + "s"] = fields[item];
                delete fields[item];
            }
        });

        if (fields.groupby === 'serviceTimeType'){
            fields.byServiceTimeType = true;
        }

        delete fields.groupby;

        return fields;
    };

    var validateForm = function () {

        var error    = null,
            form     = App.Forms.ServiceTimeUpdates.form,
            validate = form.validate();

        try {

            if (validate.status) {

                validate = validateDateAndMinutes();

                if (validate.status) {

                    validate.data = getValuesFromForm();

                }

            }

            return validate;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on validate form.", e);
            error.console();

        }
    };

    var showErrors = function (messages) {

        var monetMessage = new Monet.Form.Messages.InlineMessage();

        monetMessage.setScope("#ServiceTimeUpdates");
        monetMessage.setInfoType("error");
        monetMessage.setMessage(messages);
        monetMessage.triggerMessage();

    };

    var validateFormAndGenerateSession = function () {

        var error    = null,
            validate = null,
            router   = null;

        try {

            validate = validateForm();

            if (validate.status === true) {

                router = new App.Routers.ServiceTimeUpdates();
                router.generateSession(validate.data, showErrors);

            } else {
                showErrors(validate);
            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on validate and generate session.", e);
            error.console();
        }

    };

    this.addEventListener = function () {

        var error   = null,
            buttons = null,
            form    = App.Forms.ServiceTimeUpdates.form;

        try {

            buttons = form.getAllButtons();

            for (var i = 0, length = buttons.length; i < length; i++) {
                var button = buttons[i];
                if (button !== null) {

                    button.removeEventListener("click", validateFormAndGenerateSession);
                    button.addEventListener("click", validateFormAndGenerateSession);

                }
            }


        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "error on add EventListenner", e);
            error.console();
        }
    };

    this.destroy = function () {

        var error     = null,
            container = "#ServiceTimeUpdates #form_and_grid",
            form      = null;

        try {

            form = document.querySelector(container);

            if (form !== null) {
                form.innerHTML = "";
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this, "Error on destroy.", e);
            error.console();

        }
    };

    this.show = function () {

        var error       = null,
            tabSelector = "ServiceTimeUpdates",
            data        = [];

        try {

            data = App.Forms.ServiceTimeUpdates.layout.form;
            var baseRouter = new App.Routers.BaseRouter();
            baseRouter.renderMonetForm(tabSelector, data, tabSelector);


        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on show form search service time updates.", e);
            error.console();

        }
    };
};